<template>
  <DxCheckBox :value="selected"
              :icon-size="18"
              @value-changed="checkboxClicked"
  />
</template>

<script setup>
  import DxCheckBox from 'devextreme-vue/check-box'
  import { storeToRefs } from "pinia";
  import { useCabinetStore } from "@/stores/cabinetStore.js";
  import { useSearchPageStore } from "@/stores/searchPageStore.js";


  const props = defineProps(['selected', 'docId'])

  const searchPageStore = useSearchPageStore()
  const cabinetStore = useCabinetStore()
  const { cabinetId } = storeToRefs(cabinetStore)

  const checkboxClicked = (e) => {
    const newSelectedState = e.value
    searchPageStore.selectDocument(props.docId, newSelectedState, cabinetId.value)
  }
</script>

<style scoped lang="scss">

</style>
